import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ZiroSupportSettings } from '../../shared/models/generated/ziroModels';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ZiroSupportSettingsResource {
  private _http = inject(HttpClient);

  private _baseUrl = '/services/microsoft/admin/ziro-support-settings';

  get(): Observable<ZiroSupportSettings> {
    return this._http.get<ZiroSupportSettings>(this._baseUrl);
  }

  put(settings: ZiroSupportSettings): Observable<void> {
    return this._http.put<void>(this._baseUrl, settings);
  }
}
